/**
 * Layout main component
 * 
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Main extends PureComponent {

	static propTypes = {
		
		children: PropTypes.node,
	}

	render() {
		
		const { children } = this.props;

		return (
			
	        <main className="layout-main">
				{children}
			</main>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/layout/main/main.js